import React from 'react';
import Vector from '../../assets/icons/vector.svg';
import { useStyles, StyledUpdateButton } from './UpdateButton.styles';

interface UpdateButtonProps {
  isDisabled?: boolean;
  onClick: () => void;
  text?: string;
}

export const UpdateButton: React.FC<UpdateButtonProps> = (props) => {
  const classes = useStyles();

  return (
    <>
      <StyledUpdateButton
        onClick={props.onClick}
        className={classes.editButton}
        variant="contained"
        disabled={props.isDisabled}
        style={{ color: '#FFFFFF', backgroundColor: props.isDisabled ? '#6F707B' : '#3C419A' }}
        startIcon={props.isDisabled ? <img src={Vector}  alt='ikona aktualizacji' /> : undefined}
      >
        {props.text ? props.text : 'Aktualizuj'}
      </StyledUpdateButton>
    </>
  );
};
